export default __webpack_public_path__ + "static/media/link-linked_darkGray1.80e08c01.svg";